import { ProductContext } from "~/domains/product/ProductContext";
import { Designation } from "~/domains/product/components/Designation";
import { ShortDescription } from "~/domains/product/components/ShortDescription";
import { PrimaryImage } from "~/domains/product/components/PrimaryImage";
import { PreferredIndicator } from "~/domains/product/components/PreferredIndicator";
import { PrimaryImageWithLogos, PrimaryImageWithLogosV2 } from "~/domains/product/components/PrimaryImageWithLogos";
import { FullDesignation } from "~/domains/product/components/FullDesignation";
import { PdpLink } from "~/domains/product/components/PdpLink";
import { DescriptionV2 } from "~/domains/product/components/DescriptionV2";
import { ShortDescriptionV2 } from "~/domains/product/components/ShortDescriptionV2";
import { DesignationV2 } from "~/domains/product/components/DesignationV2";
import { PrimaryImageV2 } from "~/domains/product/components/PrimaryImageV2";
import { DesignationContainer } from "~/domains/product/components/DesignationContainer";
import { MMDChip } from "~/domains/product/components/MMDChip";
import { ReconditionableTag } from "~/domains/product/components/ReconditionableTag";
import { StockIndicator } from "~/domains/product/components/StockIndicator";

export const Product = {
  PdpLink,
  DesignationContainer,
  Designation,
  DesignationV2,
  /**
   * @deprecated - use v2 instead
   */
  ShortDescription,
  ShortDescriptionV2,
  DescriptionV2,
  PrimaryImage,
  PrimaryImageV2,
  PreferredIndicator,
  PrimaryImageWithLogos,
  PrimaryImageWithLogosV2,
  FullDesignation,
  Context: ProductContext,
  MMDChip,
  ReconditionableTag,
  StockIndicator,
};
